import { AutoComplete, Input, Tooltip, Breadcrumb, message } from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import {
  EditIcon,
  DeleteIcon,
  DetailIcon,
  SearchIcon,
  CloseIconSearch,
  AscRed,
  DescGrey,
  EditDisabled,
  DeleteDisabled,
} from "../../../asset";
import style from "./RoleList.module.css";
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { CustomerListColumn } from "../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import { useDispatch, useSelector } from "react-redux";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import CustomPaging from "../../../component/pagination/pagination";
import { GROLOG_URL } from "../../../constant/apiConstant";
import { onChanged } from "../../../util/Util";

const RoleList = (props) => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const api = GROLOG_URL;
  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState();
  const [listRecommendation, setListRecommendation] = useState([]);
  const [sorting, setSorting] = useState("asc");
  const [sortingBy, setSortingBy] = useState("id");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsfilter] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async (data, sort, sortBy, pages) => {
    let res = await doGet(
      `/role?page=${pages ? pages : page}&limit=${limit}&order=${
        sortBy ? sortBy : sortingBy
      } ${sort ? sort : sorting}${
        filter
          ? "&filter=role_id lk " + filter
          : data
          ? "&filter=role_id lk " + data
          : ""
      }&${param}`,
      token
    );
    let init = await doGet(
      `/role/initiate?page=${pages ? pages : page}&limit=${limit}&order=${
        sortBy ? sortBy : sortingBy
      } ${sort ? sort : sorting}${
        filter
          ? "&filter=role_id lk " + filter
          : data
          ? "&filter=role_id lk " + data
          : ""
      }&${param}`,
      token
    );
    setListData(res?.data?.payload?.data);
    setInitiate(init?.data?.payload?.data);
  };

  useEffect(() => {
    onChanged(dispatch, false);
    fetchData();
  }, [page, limit, filter]);

  const handleEdit = (id) => {
    navigate(ROUTES.ROLE.EDIT, { state: id });
  };

  const handleDetail = (id, created) => {
    console.log("created", created);
    navigate(ROUTES.ROLE.DETAIL, {
      state: {
        id: id,
        created_by: created,
      },
    });
  };

  const handlePagination = (a, b) => {
    if (a && b) {
      setPage(a);
      setLimit(b);
    } else {
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 3) {
      let res = await doGet(
        `/role/search?page=1&limit=10&filter=role_id lk ${filters}`,
        token
      );
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const onSearchRecommendation = async (value) => {
    setIsfilter(true);
    setSearchRecommedation(value);
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
      setFilter("")
      setPage(1)
      setLimit(10)
      setIsfilter(false);
    // setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    // fetchData("", sorting, 1);
    fetchData("", sorting,sortingBy, 1)
    }
  };

  const onSelectRecommendation = (data) => {
    setPage(1);
    setFilter(data);
    fetchData(data, sorting, 1);
    setIsfilter(false);
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setSearchRecommedation("");
    setListRecommendation([]);
    fetchData("", sorting, 1);
  };

  const options =
    listRecommendation &&
    listRecommendation.map((item) => ({
      value: item.value,
      label: item.value,
    }));

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };

  const ListColumn = [
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("ID")}
            </span>
          </div>
          <div style={{ marginLeft: "10px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={
                    sorting === "asc" && sortingBy === "id" ? AscRed : DescGrey
                  }
                  alt="asc"
                  className={
                    sorting === "asc" && sortingBy === "id"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("asc", "id");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={
                    sorting === "desc" && sortingBy === "id" ? AscRed : DescGrey
                  }
                  alt="desc"
                  className={
                    sorting === "desc" && sortingBy === "id"
                      ? "w-[10px] h-[10px] cursor-pointer rotate-180 "
                      : "w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("desc", "id");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "customerId",
      key: "customerId",
      render: (customerId) => <span>{customerId}</span>,
    },

    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Role")}
            </span>
          </div>
          <div style={{ marginLeft: "10px", marginTop: "3px" }}>
            <div className={style.SortArea}>
              <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={
                    sorting === "asc" && sortingBy === "role_id"
                      ? AscRed
                      : DescGrey
                  }
                  alt="asc"
                  className={
                    sorting === "asc" && sortingBy === "role_id"
                      ? "w-[10px] h-[10px] cursor-pointer"
                      : "rotate-180 w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("asc", "role_id");
                  }}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={
                    sorting === "desc" && sortingBy === "role_id"
                      ? AscRed
                      : DescGrey
                  }
                  alt="desc"
                  className={
                    sorting === "desc" && sortingBy === "role_id"
                      ? "w-[10px] h-[10px] cursor-pointer rotate-180 "
                      : "w-[10px] h-[10px] cursor-pointer"
                  }
                  onClick={() => {
                    doSort("desc", "role_id");
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      dataIndex: "role",
      key: "role",
      render: (role) => <span>{role}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Description")}
        </span>
      ),
      dataIndex: "description",
      key: "description",
      render: (description) => <span>{description}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Level")}
        </span>
      ),
      dataIndex: "level",
      key: "level",
      render: (level) => <span>{level}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];
  const doSort = async (sort, sortBy) => {
    await setSortingBy(sortBy);
    await setSorting(sort);
    if (sort && sortBy) {
      await setSorting(sort);
      await setSortingBy(sortBy);
      fetchData("", sort, sortBy);
    }
  };
  const dataSource = listData
    ? listData.map((result) => ({
        customerId: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.id}
          </span>
        ),

        role: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.role_id}
          </span>
        ),
        description: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.description}
          </span>
        ),
        level: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.level}
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button
                disabled={result?.created_by_sysadmin === "Y"}
                onClick={() => handleEdit(result?.id)}
              >
                <img
                  src={
                    result?.created_by_sysadmin === "Y"
                      ? EditDisabled
                      : EditIcon
                  }
                  alt="edit"
                />
              </button>
            </Tooltip>
            <Tooltip title={t("Delete")} color="#CF0000">
              <button
                disabled={result?.created_by_sysadmin === "Y"}
                onClick={() => setModal(result)}
              >
                <img
                  src={
                    result?.created_by_sysadmin === "Y"
                      ? DeleteDisabled
                      : DeleteIcon
                  }
                  alt="del"
                />
              </button>
            </Tooltip>

            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                // onClick={() => handleDelete(result?.id, result?.updated_at)}
                onClick={() =>
                  handleDetail(result?.id, result?.created_by_sysadmin)
                }
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

  return (
    <>
      <Delete
        data={data.updated_at}
        user_id={1}
        id={data.id}
        delete={showDelete}
        title={data.role_id}
        url={"role"}
        action={() => setShowDelete(false)}
        route={ROUTES.ROLE.LIST}
        refresh={() => fetchData()}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Admin`}
          menuLevel2={`User Management`}
          menuLevel3={`Role`}
        />

        <h1 className="font-sans-bold text-2xl" id="title">
          {t("Role")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <AutoComplete
            options={options}
            value={searchRecommendation}
            onChange={(value) => onSearchRecommendation(value)}
            onSelect={(value) => onSelectRecommendation(value)}
          >
            <Input
              placeholder={t("Search Role")}
              className="w-[350px] h-[47px]"
              height={47}
              width={350}
              suffix={
                <img
                  src={filter ? CloseIconSearch : SearchIcon}
                  alt="search"
                  onClick={filter ? () => onClearRecommendation() : null}
                />
              }
              // options={options}
              value={searchRecommendation}
              // onChange={(value) => onSearchRecommendation(value)}
            />
          </AutoComplete>

          <Link to={ROUTES.ROLE.ADD}>
            <PrimaryButton text={t("Add Role")} prefixIcon={<AddIcon />} />
          </Link>
        </div>

        <div className={style.tableContainer}>
          <CustomTable columns={ListColumn} data={dataSource} />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a, b) => handlePagination(a, b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleList;
